import adminRequest from '../shared/adminHttp';

class AdminService {
  // ── Accounts ───────────────────────────────────────────────────────────────

  async getAllAccounts() {
    const { data } = await adminRequest.get('/accounts');
    return data;
  }

  async getAccount(id) {
    const { data } = await adminRequest.get(`/accounts/${id}`);
    return data;
  }

  async createAccount(params) {
    const { data } = await adminRequest.post('/accounts', params);
    return data;
  }

  async updateAccount(id, params) {
    const { data } = await adminRequest.put(`/accounts/${id}`, params);
    return data;
  }

  async deactivateAccount(id) {
    await adminRequest.delete(`/accounts/${id}`);
  }

  // ── Organizations ──────────────────────────────────────────────────────────

  async getAllOrganizations() {
    const { data } = await adminRequest.get('/organizations');
    return data;
  }

  async getOrganization(id) {
    const { data } = await adminRequest.get(`/organizations/${id}`);
    return data;
  }

  async createOrganization(ownerId) {
    const { data } = await adminRequest.post('/organizations', { owner_id: ownerId });
    return data;
  }

  async getOrganizationServices(id) {
    const { data } = await adminRequest.get(`/organizations/${id}/services`);
    return data;
  }

  // ── Services ───────────────────────────────────────────────────────────────

  async createService(params) {
    const { data } = await adminRequest.post('/services', params);
    return data;
  }

  async updateService(id, params) {
    await adminRequest.put(`/services/${id}`, params);
  }

  async deleteService(id) {
    await adminRequest.delete(`/services/${id}`);
  }

  // ── Templates ──────────────────────────────────────────────────────────────

  async getAllTemplates() {
    const { data } = await adminRequest.get('/templates');
    return data;
  }

  // ── Broadcasts ─────────────────────────────────────────────────────────────

  async getAllBroadcasts() {
    const { data } = await adminRequest.get('/broadcasts');
    return data;
  }

  // ── WhatsApp Credentials ───────────────────────────────────────────────────

  async getAllCredentials() {
    const { data } = await adminRequest.get('/whatsapp');
    return data;
  }

  async getCredentialsByService(serviceId) {
    const { data } = await adminRequest.get(`/whatsapp/${serviceId}`);
    return data;
  }
}

export default new AdminService();
